<script setup>
import { computed } from 'vue';
import { MESSAGE_VARIANTS, ORIENTATION } from '../constants';

const props = defineProps({
  variant: { type: String, required: true },
  orientation: { type: String, required: true },
});

const variantClasses = {
  [MESSAGE_VARIANTS.AGENT]: 'bg-n-solid-blue text-n-slate-12',
  [MESSAGE_VARIANTS.PRIVATE]:
    'bg-n-solid-amber text-n-amber-12 [&_.prosemirror-mention-node]:font-semibold',
  [MESSAGE_VARIANTS.USER]: 'bg-n-slate-4 text-n-slate-12',
  [MESSAGE_VARIANTS.ACTIVITY]: 'bg-n-alpha-1 text-n-slate-11 text-sm',
  [MESSAGE_VARIANTS.BOT]: 'bg-n-solid-iris text-n-slate-12',
  [MESSAGE_VARIANTS.TEMPLATE]: 'bg-n-solid-iris text-n-slate-12',
  [MESSAGE_VARIANTS.ERROR]: 'bg-n-ruby-4 text-n-ruby-12',
  [MESSAGE_VARIANTS.EMAIL]: 'w-full',
  [MESSAGE_VARIANTS.UNSUPPORTED]:
    'bg-n-solid-amber/70 border border-dashed border-n-amber-12 text-n-amber-12',
};

const orientationClasses = {
  [ORIENTATION.LEFT]:
    'left-bubble rounded-xl ltr:rounded-bl-sm rtl:rounded-br-sm',
  [ORIENTATION.RIGHT]:
    'right-bubble rounded-xl ltr:rounded-br-sm rtl:rounded-bl-sm',
  [ORIENTATION.CENTER]: 'rounded-md',
};

const bubbleClasses = computed(() => [
  variantClasses[props.variant],
  props.variant === MESSAGE_VARIANTS.ACTIVITY
    ? 'rounded-lg'
    : orientationClasses[props.orientation],
  props.variant !== MESSAGE_VARIANTS.EMAIL && 'max-w-lg',
]);
</script>

<template>
  <div class="min-w-0 text-sm" :class="bubbleClasses">
    <slot />
  </div>
</template>
